// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2YBU-","modalFooterButton":"ModalNotes_modalFooterButton___jLyW"};